export function formatPhoneNumber(value: string): string {
    // Remove all non-digits except +
    const cleaned = value.replace(/[^\d+]/g, '');

    // If empty or just +, return as is
    if (!cleaned || cleaned === '+') return cleaned;

    // Handle US/Canada numbers starting with +1
    if (cleaned.startsWith('+1')) {
        const numbers = cleaned.slice(2).replace(/\D/g, '');

        if (numbers.length === 0) return '+1';
        if (numbers.length <= 3) return `+1 (${numbers}`;
        if (numbers.length <= 6) return `+1 (${numbers.slice(0, 3)}) ${numbers.slice(3)}`;

        return `+1 (${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
    }

    // Handle international numbers (keep digits and + only)
    if (cleaned.startsWith('+')) {
        // For non-US numbers, just keep digits and +, no formatting
        return cleaned;
    }

    // If no country code, assume US and add +1
    const numbers = cleaned.replace(/\D/g, '');
    if (numbers.length === 0) return '';
    if (numbers.length <= 3) return `+1 (${numbers}`;
    if (numbers.length <= 6) return `+1 (${numbers.slice(0, 3)}) ${numbers.slice(3)}`;

    return `+1 (${numbers.slice(0, 3)}) ${numbers.slice(3, 6)}-${numbers.slice(6, 10)}`;
}

export function validatePhoneNumber(phone: string): boolean {
    if (!phone) return true; // Phone is optional

    // Basic validation for US numbers: +1 (XXX) XXX-XXXX
    const usPhoneRegex = /^\+1 \(\d{3}\) \d{3}-\d{4}$/;

    // For international numbers: at least + followed by 6-15 digits
    const internationalPhoneRegex = /^\+\d{6,15}$/;

    return usPhoneRegex.test(phone) || internationalPhoneRegex.test(phone);
}

export function extractDigits(phone: string): string {
    return phone.replace(/\D/g, '');
}